import { useLanguage } from '../context/LanguageContext';
import FooterSocialIcon from './FooterSocialIcon';

function Footer() {
  const { t } = useLanguage();

  return (
    <footer id="site-footer" className="footer">
      <div className="container footer-inner">
        <div className="footer-brand-block">
          <strong className="footer-title">{t.footer.brand}</strong>
          <p className="footer-tagline">{t.footer.tagline}</p>
          <nav className="footer-social" aria-label={t.footer.socialNavAria}>
            {t.footer.socialLinks.map((link) => (
              <a
                key={link.href}
                className="footer-social-link"
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={link.label}
              >
                <FooterSocialIcon iconId={link.iconId} />
              </a>
            ))}
          </nav>
        </div>
      </div>
      <div className="footer-bottom container">
        <span>{t.footer.copy}</span>
      </div>
    </footer>
  );
}

export default Footer;
